<template src='./inactivity.html'></template>

<script>
import tabulatorMixin from '@/mixins/tabulator'
import Tabulator from '@/components/tabulator/Tabulator'
import Vue from 'vue'
import HighlightButton from '@/components/misc/HighlightButton.vue'
import moment from 'moment'
import { EventBus } from '@/router/bus'

export default {
  components: {
    Tabulator,
    HighlightButton
  },
  mixins: [tabulatorMixin],
  props: ['data', 'project', 'selectedPhase', 'projectCode', 'projectPhaseId'],
  data () {
    return {
      indicator: {},
      displayResetButton: false,
      tabulatorOptions: {
        ajaxSorting: false,
        ajaxFiltering: false,
        pagination: false,
        paginationSize: undefined,
        ajaxURLGenerator: undefined,
        headerSortElement: '',
        footerElement: '',
        layout: 'fitDataFill',
        columns: [
          {
            title: 'Г',
            field: 'year',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Година',
            formatter: (cell, formatterParams, onRendered) => {
              return '<b>' + cell.getValue() + '</b>'
            },
            minWidth: 50
          },
          {
            title: 'К',
            field: 'quarter',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Квартал',
            formatter: (cell, formatterParams, onRendered) => {
              return '<b>' + cell.getValue() + '</b>'
            },
            minWidth: 50
          },
          {
            title: 'ДЗ',
            field: 'projectEndDate',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Процењени дан завршетка пројекта (Obrazac 5, Tačka 1.3)',
            formatter: (cell, formatterParams, onRendered) => {
              var row = cell.getRow()
              var rowPosition = row.getPosition(true)
              if (rowPosition) {
                return cell.getValue() ? '<b>' + moment(cell.getValue(), 'YYYY-MM-DD').format('DD.MM.YYYY') + '</b>' : '<b>' + this.$t('general.undefined') + '</b>'
              } else {
                return cell.getValue() ? moment(cell.getValue(), 'YYYY-MM-DD').format('DD.MM.YYYY') : this.$t('general.undefined')
              }
            },
            minWidth: 100,
            editor: this.dateEditor
          },
          {
            title: 'ДЗ - ДП',
            field: 'projectEvaluationDays',
            hozAlign: 'right',
            headerHozAlign: 'right',
            formatter: (cell, formatterParams, onRendered) => {
              return '<b>' + cell.getValue() + '</b>'
            },
            minWidth: 110
          },
          {
            title: '(ДИ-ДП)/(ДЗ-ДП)',
            field: 'activity',
            hozAlign: 'right',
            headerHozAlign: 'right',
            formatter: (cell, formatterParams, onRendered) => {
              return '<b>' + cell.getValue().toFixed(0) + '</b>'
            },
            minWidth: 165
          },
          {
            title: 'НФИ',
            field: 'implementationLevel',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Ниво финансијске реализације',
            formatter: 'money',
            cssClass: 'bold-text',
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 150
          },
          {
            title: 'А 25%',
            field: 'inactivity25',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'АКТИВАН 25% (Неактивност према Извештају о напретку реализације)',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? '<b>' + this.$t('successKeyIndicator.inactivity') + '</b>' : '<b>' + this.$t('successKeyIndicator.ok') + '</b>'
            },
            minWidth: 100
          },
          {
            title: 'А 50%',
            field: 'inactivity50',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'АКТИВАН 50% (Неактивност према Извештају о напретку реализације)',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? '<b>' + this.$t('successKeyIndicator.inactivity') + '</b>' : '<b>' + this.$t('successKeyIndicator.ok') + '</b>'
            },
            minWidth: 100
          },
          {
            title: 'А 75%',
            field: 'inactivity75',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'АКТИВАН 75% (Неактивност према Извештају о напретку реализације)',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? '<b>' + this.$t('successKeyIndicator.inactivity') + '</b>' : '<b>' + this.$t('successKeyIndicator.ok') + '</b>'
            },
            minWidth: 100
          },
          {
            title: 'ДФИ',
            field: 'activityQuarterPercent',
            hozAlign: 'right',
            headerHozAlign: 'right',
            cssClass: 'bold-text',
            headerTooltip: 'Динамика финансијске реализације по кварталима према Плану реализације (Об. 5, Tačka 4.2)',
            formatter: 'money',
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 150
            // editor: 'number',
            // editorParams: {
            //   min: 0,
            //   max: 999999999999999,
            //   step: 5,
            //   elementAttributes: {
            //     maxlength: '20'
            //   }
            // }
          },
          {
            title: 'ДФИЗ',
            field: 'activityQuarterSumPercent',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Динамика финансијске реализације збирно до дана Извештаја а према Плану реализације',
            formatter: 'money',
            cssClass: 'bold-text',
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 150
          },
          {
            title: 'А 25%',
            field: 'inactivityInitial25',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'АКТИВАН 25% (Неактивност према Плану реализације)',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? '<b>' + this.$t('successKeyIndicator.inactivity') + '</b>' : '<b>' + this.$t('successKeyIndicator.ok') + '</b>'
            },
            minWidth: 100
          },
          {
            title: 'А 50%',
            field: 'inactivityInitial50',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'АКТИВАН 50% (Неактивност према Плану реализације)',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? '<b>' + this.$t('successKeyIndicator.inactivity') + '</b>' : '<b>' + this.$t('successKeyIndicator.ok') + '</b>'
            },
            minWidth: 100
          },
          {
            title: 'А 75%',
            field: 'inactivityInitial75',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'АКТИВАН 75% (Неактивност према Плану реализације)',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? '<b>' + this.$t('successKeyIndicator.inactivity') + '</b>' : '<b>' + this.$t('successKeyIndicator.ok') + '</b>'
            },
            minWidth: 100
          },
          {
            title: 'ГВН',
            field: 'value',
            hozAlign: 'right',
            headerTooltip: 'ГРАНИЧНА ВРЕДНОСТ НЕАКТИВНОСТИ',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? '<b>' + this.$t('successKeyIndicator.ok') + '</b>' : '<b>' + this.$t('successKeyIndicator.inactivity') + '</b>'
            },
            minWidth: 100
          }
        ]
      }
    }
  },
  computed: {
    getColor () {
      return this.project.phase === this.selectedPhase.phase ? 'var(--v-cards-base)' : 'var(--v-success-light-base)'
    }
  },
  methods: {
    calculate () {
      this.showLoader(true)
      this.$http.post(Vue.$apiConfig.calculateSuccessKeyIndicatorPost, { inactivity: this.data })
        .then(
          response => {
            this.logConsole(response)
            const payload = response.data.payload
            this.reloadData(payload.inactivity)
            this.displayResetButton = true
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    reset () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.successKeyIndicatorGet.replace('{projectCode}', this.projectCode).replace('{projectPhaseId}', this.projectPhaseId))
        .then(
          response => {
            this.logConsole(response)
            this.reloadData(response.data.payload.map(x => x.inactivity))
            this.displayResetButton = false
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    reloadData (data) {
      EventBus.$emit('reloadInactivityData', data)
    },
    dateEditor (cell, onRendered, success, cancel) {
      var row = cell.getRow()
      var rowPosition = row.getPosition(true)
      if (rowPosition > 0) return false
      // cell - the cell component for the editable cell
      // onRendered - function to call when the editor has been rendered
      // success - function to call to pass thesuccessfully updated value to Tabulator
      // cancel - function to call to abort the edit and return to a normal cell
      // create and style input
      var cellValue = moment(cell.getValue(), 'YYYY-MM-DD').format('YYYY-MM-DD')
      var input = document.createElement('input')

      input.setAttribute('type', 'date')

      input.style.padding = '4px'
      input.style.width = '100%'
      input.style.boxSizing = 'border-box'

      input.value = cellValue

      onRendered(function () {
        input.focus()
        input.style.height = '100%'
      })

      function onChange () {
        if (input.value !== cellValue) {
          var test = moment(input.value, 'YYYY-MM-DD').format('YYYY-MM-DD')
          success(test)
        } else {
          cancel()
        }
      }

      // submit new value on blur or change
      input.addEventListener('blur', onChange)

      // submit new value on enter
      input.addEventListener('keydown', function (e) {
        if (e.keyCode === 13) {
          onChange()
        }

        if (e.keyCode === 27) {
          cancel()
        }
      })

      return input
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    }
  }
}
</script>
<style>
  .bold-text {
    font-weight: bold;
  }
  .tabulator .tabulator-header .tabulator-col.tabulator-sortable .tabulator-col-title {
    padding-right: 0px !important;
  }
</style>
